import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AlertTriangle, Loader2 } from 'lucide-react'
import { useDeleteManagedDevice } from '../../../../hooks/useManagedDevices'
import { useRole } from '../../../../hooks/useRole'

/**
 * Última seção do detalhe do device — exclusão com confirmação.
 * Substitui o botão de "lixeira" da listagem (que foi removido).
 * Oculta para viewers (read-only).
 */
export default function DangerZoneSection({ device }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const del = useDeleteManagedDevice()
  const { canDelete } = useRole()
  const [confirm, setConfirm] = useState(false)

  const handleDelete = async () => {
    try {
      await del.mutateAsync(device.id)
      navigate('/managed-devices')
    } catch (e) {
      alert(e.response?.data?.message || e.message || t('config.dangerDeleteError'))
    }
  }

  if (!canDelete) return null

  return (
    <section className="border border-red-200 bg-red-50 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-2">
        <AlertTriangle className="w-4 h-4 text-red-600" />
        <h3 className="text-sm font-semibold text-red-800">{t('config.dangerTitle', 'Zona de perigo')}</h3>
      </div>
      <p className="text-xs text-red-700 mb-3">
        {t('managedDeviceDetail.dangerHint', 'A exclusão é permanente e remove todas as redes, rotas e regras de acesso associadas.')}
      </p>

      {!confirm ? (
        <button
          type="button"
          onClick={() => setConfirm(true)}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded"
        >
          {t('managedDeviceDetail.dangerButton', 'Excluir managed device')}
        </button>
      ) : (
        <div className="space-y-2">
          <p className="text-sm text-red-700">
            {t('config.dangerPrompt', 'Tem certeza? Esta ação não pode ser desfeita.')}
          </p>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={handleDelete}
              disabled={del.isPending}
              className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded disabled:opacity-50"
            >
              {del.isPending && <Loader2 className="w-4 h-4 animate-spin" />}
              {t('config.dangerConfirm', 'Confirmar exclusão')}
            </button>
            <button
              type="button"
              onClick={() => setConfirm(false)}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded"
            >
              {t('common.buttons.cancel', 'Cancelar')}
            </button>
          </div>
        </div>
      )}
    </section>
  )
}
